import { Quote } from 'lucide-react';
import { TESTIMONIALS } from '@/lib/brand';
import Reveal from '@/components/Reveal';

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative bg-[#0E2238] py-24 md:py-36 overflow-hidden"
    >
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[400px] rounded-full opacity-25 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse, rgba(214,179,106,0.2) 0%, transparent 70%)' }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-16 md:mb-20">
          <Reveal>
            <div className="overline text-[#D6B36A] justify-center inline-flex mb-6">Client Voices</div>
          </Reveal>
          <Reveal delay={120}>
            <h2 className="font-serif text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-6">
              Real Stories.<br />
              <span className="italic gold-text">Real Conversations</span>.
            </h2>
          </Reveal>
          <Reveal delay={240}>
            <p className="text-white/55 text-base md:text-lg font-light max-w-2xl mx-auto leading-[1.75]">
              Names have been changed to honor client privacy. The stories are theirs.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={i} delay={i * 140}>
              <article
                data-testid={`testimonial-card-${i}`}
                className="card-navy p-8 md:p-10 relative flex flex-col h-full"
              >
                <Quote className="w-8 h-8 text-[#B68A35]/50 mb-6" strokeWidth={1} />
                <p className="font-serif text-white/90 text-[1.05rem] md:text-lg leading-[1.55] mb-8 flex-1">
                  {t.quote}
                </p>
                <div className="pt-6 border-t border-white/10">
                  <p className="text-[#D6B36A] text-sm tracking-[0.18em] uppercase font-medium">{t.author}</p>
                  <p className="text-white/45 text-xs mt-1.5 font-light tracking-wide">{t.role}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={200}>
          <p className="mt-16 text-center text-white/40 text-xs tracking-[0.28em] uppercase font-light">
            Client identities protected · No performance claims made
          </p>
        </Reveal>
      </div>
    </section>
  );
}
